import {html} from 'lit-html';
import {unsafeHTML} from 'lit-html/directives/unsafe-html';

import TemplateRegistry from '../template/template-registry';
import {optionGroupLayoutStyle, collapse} from '../template/template-util.js';
import {optionsTemplate} from '../template/product-options.template.js';

TemplateRegistry.templates['group'] = (option, config, onChange, onErrorClear, getOption) => {

    const groupTemplate = html`
            <div class="cl-po--group" >
                ${option.params.groupLayout ? html`
                    <style>${optionGroupLayoutStyle(option)}</style>
                ` : null}
                ${option.options && option.options.length > 0 ? html`
                    ${optionsTemplate(option.options, config, onChange, onErrorClear, getOption)}
                ` : null}
            </div>`;

    // conditional collapse
    return option.params.collapse ? collapse(unsafeHTML(option.params.collapseLabel), groupTemplate, option.params.collapseOpen) : groupTemplate;
}